import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles';
import { SpeedCameraMenu, SpeedCamera } from '../icons/index';
import Clear from '@material-ui/icons/Clear';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';


const styles = theme => ({
	card: {
    borderRadius: 0,
    fontSize: '1.1em',
    margin: '0 9px 9px 0',
    padding: 0,
    pointerEvents: 'initial',
    width: '350px',

    '@media (max-width: 700px)': {
      margin: 0,
      width: '100%',
    },
	},
   buttonSubmit: {
    backgroundColor: '#a20808',
    color: '#fff',
    fontSize: '1rem'
  },
	header: {
		display: 'flex',
		flexDirection: 'row',
		backgroundColor: '#7d7d7d',
		color: theme.palette.common.white,
		textIndent: '10px',
		lineHeight: '2.2',
    fontFamily: 'Pluto Sans Cond Bold'
	},
	headerIcon: {
		width: '28px',
		height: '28px',
        margin: '0px 0px 0px'
	},
  headerText: {
    padding: '0px 0 0 11px'
  },
	clear: {position: 'relative', height:0, float: 'right', right: 0, color: '#fff'},
  iconBtt: {
    marginTop: '2px',
    width: '32px',
    height: '32px',
  },
	icon: {
		width: '18px',
		height: '18px',
        color: '#ffffff'
	}
});

class ContentPanel extends React.Component {
  state = {
    minimized: false // minimized / expanded
  };

  handleClose = (event, value) => {
    this.setState({ value });
  };
  handleMinimize = () => {
    this.setState({minimized : !this.state.minimized})
  }
  renderContent = () => {

  	var formState = (this.props.formState ? this.props.formState : 'default');

  	switch(formState){
  		case "default":
  			return (
		  		<CardContent style={(typeof this.props.noPadding !== 'undefined' && this.props.noPadding ? {padding: 0} : {})}>
					{this.props.children}
				</CardContent>);
  			break;
  		case "finished":
  				return (<CardContent style={{backgroundColor: '#7d7d7d4d', height: '100%'}}>
					<h4>{this.props.finMessage}</h4>
           {this.props.StartNewHandler ? (
           <Button variant="contained" component="span" onClick={this.props.StartNewHandler} className={this.props.classes.buttonSubmit}>
                {(typeof this.props.newFormText !== 'undefined' ? this.props.newFormText : window.displayText('NEW_MESSAGE'))}</Button>
           ) : ''}
				</CardContent>);
  			break;
  		case "failed":
  		    return (<CardContent style={{backgroundColor: '#ffc6c6'}}>
          <h4>{this.props.finMessage}</h4>
           {this.props.StartNewHandler ? (
            <Button variant="contained" component="span" onClick={this.props.StartNewHandler} className={this.props.classes.buttonSubmit}>
                {(typeof this.props.newFormText !== 'undefined' ? this.props.newFormText : window.displayText('NEW_MESSAGE'))}
            </Button>
          ) : ''}
        </CardContent>);
  			break;	
      case "loading":
          return (<CardContent style={(typeof this.props.noPadding !== 'undefined' && this.props.noPadding ? {padding: 0} : {})}>
          {this.props.children}
        </CardContent>);
        break;  

  	}
  	
  }
  render() {

  	if(!this.props.enabled) {
  		return null;
    }

    const {minimized} = this.state;
    
    //const minimized = typeof this.props.minimized !== 'undefined' && this.props.minimized !== null ? this.props.minimized : this.state.minimized;
  	
  	return (<Card className={this.props.classes.card}>
            <div className={this.props.classes.clear}>
                {/*<IconButton onClick={this.handleMinimize} className={this.props.classes.iconBtt} aria-label="Delete">
                {!minimized ? <KeyboardArrowUp className={this.props.classes.icon} /> : <KeyboardArrowDown className={this.props.classes.icon} />}
                </IconButton>*/}
                <IconButton onClick={this.props.onClose} className={this.props.classes.iconBtt} aria-label="Delete">
                <Clear className={this.props.classes.icon} />
                </IconButton>
            </div>
            <div className={this.props.classes.header}>
                <div className={this.props.classes.headerIcon}>{this.props.HeaderIcon}</div>
                <div className={this.props.classes.headerText} >{this.props.HeaderText}</div>
            </div>
		{(!minimized ? this.renderContent() : '')}
	</Card>);
  }
}

ContentPanel.propTypes = {
  HeaderIcon: PropTypes.object.isRequired,
//  ContentElem: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  HeaderText: PropTypes.string.isRequired,
  newFormText: PropTypes.string,
  StartNew: PropTypes.string,
  StartNewHandler: PropTypes.func,
  finMessage: PropTypes.string,
  formState: PropTypes.oneOf(['default', 'finished', 'failed', 'loading']),
  onClose: PropTypes.func.isRequired,
  noPadding: PropTypes.bool
}

export default withStyles(styles)(ContentPanel);


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/contentPanel/index.js